import type { StrokeOpts as CKStrokeOpts } from 'canvaskit';
import type { StrokeOpts } from './StrokeOpts';
import { toCkStrokeCap, toCkStrokeJoin } from './Visual';

export function toCkStrokeOpts(opts?: Partial<StrokeOpts>): CKStrokeOpts | undefined {
  if (!opts) {
    return undefined;
  }
  return {
    width: opts.width,
    miter_limit: opts.miter_limit,
    precision: opts.precision,
    join: toCkStrokeJoin(opts.join),
    cap: toCkStrokeCap(opts.cap)
  };
}
